import React, { useEffect } from "react";
import { AppInterface } from "src/store/community/appsSlice";

import { Button, Form, Input } from "antd";
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params?: AppInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='icon' label='Icon' preview={params?.icon_url} />

      <Form.Item name='name' label="Name">
        <Input />
      </Form.Item>

      <Form.Item name='notes' label="Notes">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
